function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["label", "id", "type", "inputMode", "view", "isLabelShort", "isDisabled", "caption", "icon", "hint", "hintInfo", "hintError", "hintWarning", "hintView", "hintPosition", "styles", "allowedSymbols", "mask", "isLabelAboveValueOnMobile"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.function.name.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import Media from 'react-media';
import { numberOnly } from '../../utils/numberOnly';
import { FieldContainer, FieldEmotion, Label, InputEmotion, Caption, Icon } from './styles';
import { media } from '../../styles/MediaQueries';
import MaskedInput from 'react-text-mask';
import { InputHint } from './Hint';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var viewType = ['small', 'medium', 'big'];
export function Input(props) {
  var label = props.label,
    id = props.id,
    type = props.type,
    inputMode = props.inputMode,
    _props$view = props.view,
    view = _props$view === void 0 ? 'medium' : _props$view,
    isLabelShort = props.isLabelShort,
    isDisabled = props.isDisabled,
    caption = props.caption,
    icon = props.icon,
    hint = props.hint,
    hintInfo = props.hintInfo,
    hintError = props.hintError,
    hintWarning = props.hintWarning,
    _props$hintView = props.hintView,
    hintView = _props$hintView === void 0 ? 'error' : _props$hintView,
    _props$hintPosition = props.hintPosition,
    hintPosition = _props$hintPosition === void 0 ? 'right' : _props$hintPosition,
    styles = props.styles,
    allowedSymbols = props.allowedSymbols,
    mask = props.mask,
    isLabelAboveValueOnMobile = props.isLabelAboveValueOnMobile,
    restProps = _objectWithoutProperties(props, _excluded);
  var isHintVisible = Boolean(hint || hintInfo || hintError || hintWarning);

  // Добавляем флаг /g на случай если забыли его явно передать
  var allowedSymbolsRegexp = allowedSymbols && new RegExp(allowedSymbols, 'g');
  return _jsx(Media, {
    queries: media,
    children: function children(media) {
      var hintPositionAllowable = media.mobile ? 'bottom-static' : hintPosition;
      return _jsxs(FieldContainer, {
        isHintDefault: hintPosition === 'default' || hintPositionAllowable === 'bottom-static',
        isHintVisible: isHintVisible,
        view: view,
        css: styles === null || styles === void 0 ? void 0 : styles.container,
        children: [_jsxs(FieldEmotion, {
          isDisabled: isDisabled,
          isLabelAboveValueOnMobile: isLabelAboveValueOnMobile,
          sizeInput: view,
          css: styles === null || styles === void 0 ? void 0 : styles.field,
          children: [label && _jsx(Label, {
            htmlFor: id,
            size: view,
            isShort: isLabelShort,
            css: styles === null || styles === void 0 ? void 0 : styles.label,
            children: label
          }), _jsx(MaskedInput, _objectSpread(_objectSpread({
            mask: mask ? mask : false,
            guide: false
          }, props), {}, {
            render: function render(ref, props) {
              return _jsx(InputEmotion, _objectSpread(_objectSpread({}, restProps), {}, {
                ref: ref,
                id: id,
                sizeInput: view,
                disabled: isDisabled,
                type: type === 'number' ? 'text' : type,
                inputMode: type === 'number' ? 'decimal' : inputMode,
                css: styles === null || styles === void 0 ? void 0 : styles.input,
                onKeyDown: function onKeyDown(event) {
                  // Задача на приведение валидации в порядок - https://tracker.unitedtraders.team/browse/PAYMENT-1886
                  //@ts-ignore
                  if (props.onKeyDown) {
                    //@ts-ignore
                    props.onKeyDown(event);
                  }
                  if (allowedSymbolsRegexp) {
                    var allowedKeys = ['Backspace', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight'];
                    if (!allowedKeys.includes(event.key) && !event.ctrlKey && !event.metaKey && !event.key.match(allowedSymbolsRegexp)) {
                      event.preventDefault();
                    }
                  }
                },
                onChange: function onChange(event) {
                  var _props$onChange;
                  if (type === 'number') {
                    event.target.value = numberOnly(event.target.value);
                  } else {
                    if (allowedSymbolsRegexp && !event.target.value.match(allowedSymbolsRegexp) && event.target.value !== '') {
                      event.preventDefault();
                    }
                  }
                  (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, event);
                },
                onPaste: function onPaste(event) {
                  var data = event.clipboardData.getData('text');
                  if (allowedSymbolsRegexp && !data.match(allowedSymbolsRegexp)) {
                    event.preventDefault();
                  } else {
                    var _props$onPaste;
                    // @ts-ignore
                    (_props$onPaste = props.onPaste) === null || _props$onPaste === void 0 ? void 0 : _props$onPaste.call(props, event);
                  }
                }
              }));
            }
          })), caption && _jsx(Caption, {
            children: caption
          }), icon && _jsx(Icon, {
            children: icon
          })]
        }), _jsx(InputHint, {
          name: props.name,
          view: hintView,
          position: hintPositionAllowable,
          content: hint,
          info: hintInfo,
          warning: hintWarning,
          error: hintError
        })]
      });
    }
  });
}
//# sourceMappingURL=index.js.map